export enum SizeUnit {
  Imperial = 'imperial',
  Metric = 'metric',
  Digital = 'digital'
}
